import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface LaundroworksSettings {
  id: number;
  storeId: number;
  username: string;
  password: string;
  customerKey: string;
  laundroworksLocationId: string;
  laundroworksPosNumber: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  isDeleted: boolean;
  accessToken?: string;
}

export type LaundroworksSettingsResponse = Record<string, LaundroworksSettings>;

export const getLaundroworksSettings = (
  businessId: number | string,
): AxiosPromise<LaundroworksSettingsResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/laundroworks/settings/${businessId}`,
  });
};
